import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/import.svg
 */
const IconImport: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M7 3h8.586L20 7.414V20a1 1 0 01-1 1H7a1 1 0 01-1-1v-5H5v5a2 2 0 002 2h12a2 2 0 002-2V7l-5-5H7a2 2 0 00-2 2v6h1V4a1 1 0 011-1z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 3h1v4h4v1h-5V3z"
      fill="currentColor"
    />
    <path d="M3 14v-3h9v3H3z" fill="currentColor" />
    <path d="M11.125 17V8L16 12.5 11.125 17z" fill="currentColor" />
  </svg>
);

export default IconImport;
